module.exports = __webpack_public_path__ + "static/media/bullyzero.c2301327.png";